import { WlWindow } from 'typings/globals/cordova';
import { isCordova } from './platform';

declare const window: WlWindow;

export default function showAlert(text, title = '', buttons = [], callbackFn = () => {}) {
  if (isCordova()) {
    window.navigator.notification.alert(text, callbackFn, title, buttons);
  } else {
    alert(`${title}\n\n${text}`);
  }
}
